module.exports = __webpack_public_path__ + "img/閉幕.ccf2272a.jpg";